// Add events
document.addEventListener('DOMContentLoaded', function () {

  // Check for weather request through data attribute
  let weatherContainer = document.querySelector('[data-weather-fetch]');
  if (!weatherContainer) return;

  // Get weather data from api
  fetch('/api/weather')
    .then(response => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.json();
    })
    .then(weather => {
      if (weather) {
        console.log(weather);

        // Hide widget if data to old (2 hours)
        if ((Math.floor(Date.now() / 1000)) - weather.sensor51.timestamp > 7200) {
          let weatherWidgets = document.querySelectorAll('.course-weather');
          if (weatherWidgets) {
            weatherWidgets.forEach(weatherWidget => {
              weatherWidget.style.display = 'none';
            });
          }
        }

        // Temperature
        let temperatureValues = document.querySelectorAll('[data-weather-temperature]');
        if (temperatureValues) {
          temperatureValues.forEach(element => {
            element.innerHTML = weather.sensor51.temperature + ' °C';
          });
        }

        // Wind speed
        let windSpeedValues = document.querySelectorAll('[data-weather-windspeed]');
        windSpeedValues.forEach(element => {
          element.innerHTML = weather.sensor51.windSpeed + ' km/h';
        });

        // Set content visible
        weatherContainer.classList.add('active');
      }
    })
    .catch(error => {
      console.error('Fehler beim Abrufen der Wetterdaten:', error);
    });
});
